<template>
  <v-content class="z-app-content-light">
    <v-container style="background-color:floralwhite;">
      <v-layout>
        <v-fab-transition>
          <v-btn
            class="hidden-md-and-up floating-book-mark"
            color="pink"
            dark
            absolute
            top
            left
            fab
            @click.stop="docNav = !docNav"
          >
            <v-icon>mdi-book</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-flex md3 sm12 xs12 v-show="$vuetify.breakpoint.mdAndUp || docNav">
          <v-navigation-drawer left permanent>
            <ul class="guide-menu">
              <li v-for="item in items" :key="item.title">
                <router-link
                  v-if="item.tag"
                  :to="'/guide/' + item.tag"
                  color="#2b3e50"
                  :class="{
                    'guid-menu-link': true,
                    active: docTag === item.tag,
                  }"
                >
                  {{ item.title }}
                </router-link>
                <div v-else>
                  {{ item.title }}
                </div>
                <div
                  v-if="docTag === item.tag"
                  class="toc_container"
                  v-bind:id="'tagToc_' + item.tag"
                ></div>
              </li>
            </ul>
          </v-navigation-drawer>
        </v-flex>
        <v-flex md9 sm12 xs12>
          <v-card>
            <v-container>
              <vue-markdown
                :source="doc"
                toc
                typographer
                :toc-id="docTagToc"
                @rendered="rendered"
              ></vue-markdown>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import VueMarkdown from "vue-markdown";
import axios from "axios";
import Prism from "prismjs";
import "prismjs/components/prism-bash";
import "prismjs/themes/prism-solarizedlight.css";

export default {
  name: "Guide",
  components: { VueMarkdown },
  data: () => ({
    doc: "Loading...",
    docNav: false,
    docTag: "introduction",
    docTagToc: "tagToc_introduction",
    items: [
      {
        title: "PROLOGUE",
      },
      {
        title: "Introduction",
        tag: "introduction",
      },
      {
        title: "Contribution Guide",
        tag: "contribution-guide",
      },
      {
        title: "Release Notes",
        tag: "release-notes",
      },
      { title: "GETTING STARTED" },
      {
        title: "Installation",
        tag: "installation",
      },
      {
        title: "Directory Structure",
        tag: "directory-structure",
      },
      { title: "Package Development" },
      {
        title: "Create A Package",
        tag: "create-package",
      },
      { title: "MODULES" },
      {
        title: "Zento_Kernel Module",
        tag: "module-kernel",
      },
      {
        title: "Zento_RouteUrlRewrite Module",
        tag: "module-route-urlrewrite",
      },
      {
        title: "Zento_Passport Module",
        tag: "module-passport",
      },
      {
        title: "Zento_Acl Module",
        tag: "module-acl",
      },
      {
        title: "Zento_BladeTheme Module",
        tag: "module-bladetheme",
      },

      {
        title: "Zento_VueTheme Module",
        tag: "module-vuetheme",
      },
    ],
  }),
  created() {
    this.getMdfile();
  },

  methods: {
    getMdfile() {
      if (this.$route.params.tag !== undefined) {
        this.docTag = this.$route.params.tag;
      }
      this.docTagToc = `tagToc_${this.docTag}`;

      axios
        .get(
          `https://raw.githubusercontent.com/alphazento/alphazento_docs/master/guide/${this.docTag}.md`
        )
        .then((response) => {
          this.doc = response.data;
        });
      const tag = this.items.find((el) => el.tag == this.docTag);
      document.title = tag.title + " | Alphazento";
    },
    rendered() {
      this.$nextTick(() => {
        Prism.highlightAll();
      });
    },
  },

  watch: {
    $route() {
      this.getMdfile();
    },
  },
};
</script>

<style lang="scss">
.floating-book-mark {
  position: fixed;
  top: 65px !important;
  left: 0 !important;
}
.toc-anchor-link {
  display: none;
}
ul.guide-menu {
  list-style-type: none;
  li {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    div {
      padding-top: 0.8rem;
      font-weight: bold;
      color: black;
    }
  }
}
.guid-menu-link {
  color: #2b3e50;
  &.active {
    color: #00c58e;
    font-weight: bold;
  }
}
div.toc_container {
  padding-top: 0 !important;
  font-weight: unset !important;
  ul.table-of-contents {
    list-style-type: none;
    li {
      padding-top: 0.3rem;
      padding-bottom: 0.3rem;
      ul {
        list-style-type: none;
      }
    }
  }
}
</style>
